import { CustomSelectShadcn } from "../../../components/custom-select-shadcn.component";
import { SelectProps } from "../../form-types";
import { GuarantorEntityType } from "../../../../../lib/supabase/supabaseTypes";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { getGuarantorDisplayName } from "@/dentlab/src/lib/utils/guarantor-utils";

const GuarantorSelectBare: React.FC<
	SelectProps & {
		guarantors: GuarantorEntityType[];
	}
> = (props) => {
	const options = [
		{
			value: "",
			label: "Kein Garant",
		},
		...props.guarantors.map((g) => ({
			value: g.id,
			label: getGuarantorDisplayName(g),
		})),
	];

	return (
		<CustomSelectShadcn
			options={options}
			inputLabel="Garant"
			value={props.value}
			onChange={(value) => props.onChange(value?.toString() || null)}
			disabled={props.disabled}
			densitySize={props.densitySize}
			inputHeight={props.inputHeight}
			width={props.width}
			required={props.required}
			validationError={props.validationError}
		/>
	);
};

export const GuarantorSelect: React.FC<SelectProps> = (props) => {
	const guarantors = useCentralStore((state) =>
		Object.values(state.guarantorLookup ?? {})
	);
	return <GuarantorSelectBare guarantors={guarantors} {...props} />;
};
